export default function (components) {
    if (!components || typeof components !== 'object') return
    Object.values(components).forEach(component => {
        if (!component || typeof component !== 'object') return
        const { inject, render } = component
        if (!render) return
        component.render = function (...rest) {
            if (this.getFormItemLazy && this.getFormItemLazy()) return null
            return render.bind(this)(...rest)
        }

        component.inject = inject || {}
        component.inject.getFormItemLazy = {
            default: () => false,
        }
    })
}
